import React, { useState } from 'react';

function PresidentPopup() {
  const [show, setShow] = useState(true);

  const close = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="chairman-overlay" onClick={close}>
      <div className="chairman-modal" onClick={(e) => e.stopPropagation()}>
        <button className="chairman-close" onClick={close}>✕</button>

        {/* Top Gold Banner */}
        <div className="chairman-banner">
          <span>🎓 Admissions Open — 2026–27</span>
        </div>

        <div className="chairman-body">
          {/* Left: Photo */}
          <div className="chairman-photo-side">
            <div className="chairman-photo-wrap">
              <img src="/president.jpg" alt="Founder & President Manjesh R. Naik" className="chairman-photo" />
            </div>
            <div className="chairman-id">
              <h3>Sri. Manjesh R. Naik</h3>
              <p>Founder & President</p>
              <p>Paramananda College of Nursing</p>
            </div>
          </div>

          {/* Right: Message */}
          <div className="chairman-message-side">
            <div className="chairman-welcome-badge">Welcome Message</div>
            <h2>Message from the Founder & President</h2>
            <div className="chairman-quote-mark">"</div>
            <p className="chairman-quote">
              It is with immense pride and joy that I welcome you to Paramananda College of Nursing —
              an institution built on the pillars of Compassion, Knowledge, and Excellence.
              Our vision is to nurture the next generation of skilled nurses who will serve humanity
              with dedication and transform healthcare in India and beyond.
            </p>
            <p className="chairman-quote">
              We are committed to providing world-class education, modern infrastructure, and
              clinical exposure that prepares our students to excel in any healthcare setting across the globe.
              I invite you to be a part of the PCN family and embark on a rewarding journey in nursing.
            </p>
            <div className="chairman-popup-btns">
              <a href="#president" className="btn-gold" onClick={close}>Know More</a>
              <button className="btn-navy-outline" onClick={close}>Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PresidentPopup;
